export default () => ({
  "1744305721578": {
    id: 1744305721578,
    order: 0,
    titulo: "Local",
    perguntas: {
      "1744305735213": {
        id: 1744305735213,
        tipo: "local_acessivel",
        order: 0,
        titulo: "O local est\u00e1 acess\u00edvel?",
        min_fotos: 0,
        obrigatorio: true,
      },
    },
  },
  "1744305764533": {
    id: 1744305764533,
    order: 1,
    titulo: "Sobre o alvar\u00e1",
    perguntas: {
      "1744305800211": {
        id: 1744305800211,
        tipo: "radio",
        acoes: [
          {
            op: {
              eq: 1744305804981,
            },
            run: ["alvara_concluir_vistoria.em_andamento"],
          },
          {
            op: {
              eq: 1744305874473,
            },
            run: ["alvara_concluir_vistoria.liberado_definitivo"],
          },
          {
            op: {
              eq: 1744305897573,
            },
            run: ["alvara_concluir_vistoria.liberado_provisorio"],
          },
          {
            op: {
              eq: 1744305907185,
            },
            run: ["alvara_concluir_vistoria.nao_liberado"],
          },
          {
            op: {
              eq: 1744305915450,
            },
            run: ["alvara_concluir_vistoria.nao_concluido"],
          },
          {
            op: {
              eq: 1744305923701,
            },
            run: ["alvara_concluir_vistoria.cancelado"],
          },
          {
            op: {
              eq: 1744305930049,
            },
            run: ["alvara_concluir_vistoria.indeferido"],
          },
          {
            op: {
              eq: 1744305936484,
            },
            run: ["alvara_concluir_vistoria.liberado_liberdade_economica"],
          },
          {
            op: {
              eq: 1744305949456,
            },
            run: ["alvara_concluir_vistoria.local_fechado"],
          },
        ],
        order: 0,
        titulo: "Situa\u00e7\u00e3o do alvar\u00e1",
        min_fotos: 2,
        obrigatorio: true,
        alternativas: {
          "1744305804981": {
            id: 1744305804981,
            order: 0,
            titulo: "Em andamento",
          },
          "1744305874473": {
            id: 1744305874473,
            order: 1,
            titulo: "Liberado definitivo",
          },
          "1744305897573": {
            id: 1744305897573,
            order: 2,
            titulo: "Liberado provis\u00f3rio",
          },
          "1744305907185": {
            id: 1744305907185,
            order: 3,
            titulo: "N\u00e3o liberado",
          },
          "1744305915450": {
            id: 1744305915450,
            order: 4,
            titulo: "N\u00e3o conclu\u00eddo",
          },
          "1744305923701": {
            id: 1744305923701,
            order: 5,
            titulo: "Cancelado",
          },
          "1744305930049": {
            id: 1744305930049,
            order: 6,
            titulo: "Indeferido",
          },
          "1744305936484": {
            id: 1744305936484,
            order: 7,
            titulo: "Liberado - liberdade econ\u00f4mica",
          },
          "1744305949456": {
            id: 1744305949456,
            order: 8,
            titulo: "Vistoria n\u00e3o realizada/local fechado",
          },
        },
      },
    },
  },
})
